import { post } from '@namespace/helpers';
import apiRoutes from './apiRoutes';

export const updateFreshChatUser = (data) =>
  post(apiRoutes.updateFreshChatUserData, data);
